export const polygonSymbol = {
  "type": "simple-fill",
  "color": "rgba(0,0,0,.1)",
  "outline": {
    "type": "simple-line",
    "color": "black",
    "style": "solid",
    "width": 2
  }
};